import { InfoDialog } from '../../../common/dialogs/InfoDialog';
import { Typography } from '@sweep-io/sweep-design';
import { Stack } from '@mui/material';
import useIsManagedPackageInstalled from '../../../common/install-managed-package/useIsManagedPackageInstalled';
import { ActionsRequireMp } from '../../../common/install-managed-package/getInstallManagedPackageText';
import { NoManagedPackageError } from '../../../common/error-pages/NoManagedPackageError';
import { AppsConnection } from './AppsConnection';

export type SfAppElement = {
  label: string;
  developerName: string;
  logoUrl?: string;
  hasSweepSupport: boolean;
};

const AppsConnectionDialog = ({
  closeDialog,
  checkForManagePackage,
}: {
  closeDialog: (event: any, isRefresh?: boolean) => void;
  checkForManagePackage?: boolean;
}) => {
  const isManagedPackagedInstalled = useIsManagedPackageInstalled();
  const renderMPInfo = checkForManagePackage && !isManagedPackagedInstalled;

  return (
    <InfoDialog
      handleClose={(e) => {
        e.stopPropagation();
        closeDialog(e);
      }}
      closeButtonSize="small"
      open={true}
      PaperPropsSx={{ width: renderMPInfo ? '529px' : '588px', p: renderMPInfo ? 3 : 0 }}
      showCloseButton
      titleJsx={
        renderMPInfo ? null : (
          <Typography variant="h3">Add Support AI Assistant to Salesforce</Typography>
        )
      }
      dialogContentSx={{ p: 0 }}
      dialogTitleSx={{ p: 2, pt: 3, paddingBottom: '8px !important' }}
    >
      {checkForManagePackage && !isManagedPackagedInstalled ? (
        <Stack
          sx={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
          onClick={(e) => e.stopPropagation()}
        >
          <NoManagedPackageError actionType={ActionsRequireMp.AI} />
        </Stack>
      ) : (
        <AppsConnection closeDialog={closeDialog} />
      )}
    </InfoDialog>
  );
};

export default AppsConnectionDialog;
